export default __webpack_public_path__ + "static/logo-690696d3b459f7b54add21d2ea972c2b.png";